"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrs24Values = void 0;
var utils_1 = require("@time-input-polyfill/utils");
var hrs24Values = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, cyInput = utils.cyInput, hasReturnVal = utils.hasReturnVal, use = utils.use, setTime = utils.setTime;
    describe('Hours - 24 hour tests', function () {
        increment();
        decrement();
        function increment() {
            it('increment 00:30 to 23:30', function () {
                loadPrimaryInput().then(function () {
                    setTime('12:30 AM', 'hrs12').then(function () {
                        for (var i = 0; i < 12; i++) {
                            cyInput().then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(i), ":30"))).then(use.upArrow);
                        }
                    });
                    setTime('12:30 PM', 'hrs12').then(function () {
                        for (var i = 12; i < 24; i++) {
                            cyInput().then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(i), ":30"))).then(use.upArrow);
                        }
                    });
                });
            });
        }
        function decrement() {
            it('decrement 00:30 to 23:30', function () {
                loadPrimaryInput().then(function () {
                    setTime('11:30 PM', 'hrs12').then(function () {
                        for (var i = 23; i > 12; i--) {
                            cyInput().then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(i), ":30"))).then(use.downArrow);
                        }
                    });
                    setTime('11:30 AM', 'hrs12').then(function () {
                        for (var i = 11; i >= 0; i--) {
                            cyInput().then(hasReturnVal("".concat((0, utils_1.toLeadingZero)(i), ":30"))).then(use.downArrow);
                        }
                    });
                });
            });
        }
    });
};
exports.hrs24Values = hrs24Values;
